import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const VerticalCardListFocus = styled.div<React.CSSProperties>`
  border: ${4 * Screen.widthRatio}px solid white;
  border-radius: ${24 * Screen.widthRatio}px;
  height: ${300 * Screen.widthRatio}px;
  position: absolute;
  width: ${200 * Screen.widthRatio}px;
`;

export default VerticalCardListFocus;
